import { render } from "./matchImages.vue?vue&type=template&id=619e2a68&scoped=true"
import script from "./matchImages.vue?vue&type=script&lang=js"
export * from "./matchImages.vue?vue&type=script&lang=js"

import "./matchImages.vue?vue&type=style&index=0&id=619e2a68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619e2a68"]])

export default __exports__